import localStorage from 'utils/localStorage';

export default () => localStorage.getItem('enums') || {};
